import profile from "../../Assets/icon/profile.svg";
import Messgage from "../../Assets/icon/messageIcon.svg";
import list from "../../Assets/icon/list.svg";

import resume from "../../Assets/icon/resume.svg";
import dashboard from "../../Assets/icon/dashboard.svg";
import weekly from "../../Assets/icon/weekly.svg";
import setting from "../../Assets/icon/settings.svg";
import { RoutePath } from "../../Utility/RoutePath";

let width = window.innerWidth;
export const SideMenuItemList = (currentPath) => {
  return [
    {
      key: 0,
      title: {
        fa: "لیست اساتید",
        en: "My Lessons",
      },
      value: "teacherList",
      path: "/find-teachers",
      absloutePath: "",
      roles: ["Teacher", "Student"],
      icon: list,
      toggle: false,
      hasSubCategory: false,
      subCategories: [],
      screenMaxSize: 768,
      needLoggedIn: false,
    },
    {
      key: 1,
      title: {
        fa: "کلاس های من",
        en: "My Lessons",
      },
      value: "dashboard",
      path: RoutePath.lessons,
      absloutePath: "",
      roles: ["Teacher", "Student"],
      icon: list,
      toggle: false,
      hasSubCategory: false,
      subCategories: [],
      screenMaxSize: width,
      needLoggedIn: true,
    },
    {
      key: 2,
      title: {
        fa: "داشبورد",
        en: "Dashboard",
      },
      value: "dashboard",
      path: "/",
      absloutePath: "/dashboard",
      roles: ["Teacher", "Student"],
      icon: dashboard,
      toggle: false,
      hasSubCategory: false,
      subCategories: [],
      screenMaxSize: width,
      needLoggedIn: true,
    },
    {
      key: 3,
      title: {
        fa: "پروفایل",
        en: "Resume",
      },
      value: "profile",
      path: "/",
      absloutePath: "/profile",
      roles: ["Teacher", "Student"],
      icon: profile,
      toggle: false,
      hasSubCategory: false,
      subCategories: [],
      screenMaxSize: width,
      needLoggedIn: true,
    },
    {
      key: 4,
      title: {
        fa: "رزومه",
        en: "Resume",
      },
      value: "resume",
      path: "#1",
      absloutePath: "/profile",
      roles: ["Teacher"],
      icon: resume,
      toggle: false,
      hasSubCategory: false,
      subCategories: [],
      screenMaxSize: width,
      needLoggedIn: true,
    },
    {
      key: 5,
      title: {
        fa: "قیمت و زمانبندی کلاس",
        en: "Lessons and Availability",
      },
      name: "",
      value: "weekly",
      path: "/weekly",
      absloutePath: "/profile",
      roles: ["Teacher"],
      icon: weekly,
      screenMaxSize: width,
      needLoggedIn: true,
      hasSubCategory: true,
      subCategories: [
        {
          name: "قیمت کلاس",
          value: "lessons",
          path: "/lessons",
          absloutePath: "/profile/lessons",
        },
        {
          name: "برنامه هفتگی",
          value: "weekly",
          path: "/weekly",
          absloutePath: "/profile/weekly",
        },
        {
          name: "تقویم",
          value: "calendar",
          path: "/calendar",
          absloutePath: "/profile/calendar",
        },
      ],
      toggle: [
        "/profile/lessons",
        "/profile/weekly",
        "/profile/calendar",
      ].includes(currentPath),
    },
    {
      key: 6,
      title: {
        fa: "تنظیمات",
        en: "تنظیمات",
      },
      value: "setting",
      path: "/setting",
      absloutePath: "/profile",
      roles: ["Teacher", "Student"],
      icon: setting,
      screenMaxSize: width,
      needLoggedIn: true,
      hasSubCategory: false,
      toggle: false,
      subCategories: [],
    },
  ];
};
